export const headerName = {
  add: "Добавить диапазон регистрационных номеров МС",
  edit: "Редактировать диапазон регистрационных номеров МС",
};
export const rangeMSData = {
  sctName: {
    key: "sctName",
    label: "Название участка",
    type: "selectSearch",
    options: [],
    required: true,
    isDisabled: true,
  },
  series: {
    key: "series",
    label: "Серия",
    type: "text",
    required: true,
    disabled: true,
  },
  numStart: {
    key: "numStart",
    label: "Номер с",
    type: "text",
    required: true,
    disabled: true,
  },
  numEnd: {
    key: "numEnd",
    label: "Номер по",
    type: "text",
    required: true,
    disabled: true,
  },
  dateStart: {
    key: "dateStart",
    label: "Дата начала",
    type: "date",
    required: true,
    disabled: true,
  },
  dateEnd: {
    key: "dateEnd",
    label: "Дата окончания",
    type: "date",
    disabled: true,
  },
};

export const setDataRangeMS = async (prop, field) => {
  if (prop) {
    switch (field) {
      case "sctName": {
        rangeMSData.sctName.options = prop.map((item) => {
          return {
            label: item.sctName,
            value: item.sctId,
            key: "sctName",
          };
        });
        break;
      }
    }
  }
};

export const setFieldsStateByMode = async (mode) => {
  if (mode === "add") {
    Object.keys(rangeMSData).forEach((key) => {
      if (rangeMSData[key].type === "selectSearch") {
        rangeMSData[key].isDisabled = false;
      } else rangeMSData[key].disabled = false;
    });
  } else {
    Object.keys(rangeMSData).forEach((key) => {
      if (rangeMSData[key].type === "selectSearch") {
        rangeMSData[key].isDisabled = true;
      } else rangeMSData[key].disabled = key === "dateEnd" ? false : true;
    });
  }
};

export const getRangeMSModal = () => rangeMSData;
